import i18next from 'i18next';

export function translate(key: string | null, options?: any): string {
    const currentLang = i18next.language || 'en';
    if (!key) {
        return '_';
    }
    const hasCurrent = i18next.exists(key, { lng: currentLang });
    const hasEnglish = i18next.exists(key, { lng: 'en' });

    if (!hasCurrent && hasEnglish) {
        const english = i18next.t(key, {
            lng: 'en',
            returnObjects: false,
            ...options,
        }) as unknown as string;

        return `_${english}`;
    }

    return i18next.t(key, {
        lng: currentLang,
        returnObjects: false,
        ...options,
    }) as unknown as string;
}
